"use client";
import { signOutAction } from "@/actions/auth-action";
import { LogoutIcon, PasswordIcon, UserIcon } from "@/icons";
import { PathConstant } from "@/const";
import useSession from "@/hooks/useSession";
import { ISession } from "@/models";
import { CommonUtils } from "@/utils";
import { Avatar, Box, Popover } from "@mui/material";
import Link from "next/link";
import { useEffect, useState } from "react";

const Profile = ({ session }: { session: ISession | null }) => {
  const { setSession } = useSession();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const lastName = CommonUtils.getFirstCharName(session?.user?.fullName);
  const bgUser = CommonUtils.getRandomColor(lastName ?? "");
  const handleProfileOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleProfileClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    setSession(undefined);
    await signOutAction();
    localStorage.clear();
    window.location.href = PathConstant.LOGIN;
  };

  return (
    <Box className="flex flex-row items-center gap-2">
      <Box className="flex flex-col h-full">
        <Box className="font-semibold text-right h5 text-white">
          {session?.user?.fullName}
        </Box>
        <Box className=" text-right h7 text-white">{session?.user?.role}</Box>
      </Box>

      <Avatar
        aria-haspopup="true"
        sx={{
          cursor: "pointer",
          width: 44,
          height: 44,
          bgcolor: bgUser,
        }}
        onClick={handleProfileOpen}
      >
        {lastName}
      </Avatar>

      <Popover
        onClose={handleProfileClose}
        disableRestoreFocus
        className="mt-2"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            className: "dropdown-custom dropdowm-profile",
          },
        }}
      >
        {/* <Link href="/thong-tin-thi-sinh" className="dropdown-item h6">
          <UserIcon className="w-5 h-5 h3" />
          <span>Tài khoản của tôi</span>
        </Link> */}

        <Link href={PathConstant.CHANGE_PASSWORD} className="dropdown-item h6">
          <PasswordIcon className="w-5 h-5 h3" />
          <span>Đổi mật khẩu</span>
        </Link>

        <Box
          className="dropdown-item text-h6 text-primary-red-color cursor-pointer"
          onClick={handleLogout}
        >
          <LogoutIcon className="w-h63" />
          <span>Đăng xuất</span>
        </Box>
      </Popover>
    </Box>
  );
};

export default Profile;
